import styled from "styled-components";

export const ProductDetailsWrapper = styled.div`
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem;
  flex-wrap: wrap;
  margin: auto;
  background-color: ${({ theme }) => theme.bg.prim_500};
  border-radius: 0.25rem;

  @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .product-details {
    width: 100%;
    display: flex;

    @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
      flex-direction: column;
    }
  }

  .loading-text {
    color: ${({ theme }) => theme.bg.secondary};
    font-size: 1.2rem;
    font-weight: 400;
  }

  .carousel-wrapper {
    width: 50%;

    @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
      width: 100%;
    }
  }
  .details {
    width: 50%;
    padding: 0 3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
      width: 100%;
      padding: 0;
    }

    .top {
      margin-bottom: 1.5rem;

      .brand {
        font-size: 1.2rem;
        font-weight: 700;
        color: ${({ theme }) => theme.text.primary};
      }

      .company {
        font-size: 0.9rem;
        font-weight: 600;
        margin-bottom: 10px;
      }
      .name {
        color: ${({ theme }) => theme.text.prim_100};
        font-weight: 500;
        font-size: 1.1rem;
      }
    }

    .further-details {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .item {
      min-width: 45%;
      display: flex;
      flex-direction: column;
      gap: 0.4rem;

      .title {
        color: ${({ theme }) => theme.text.prim_100};
        font-weight: 400;
        font-size: 0.85rem;
      }

      .value {
        color: ${({ theme }) => theme.text.prim_100};
        font-weight: 600;
        font-size: 0.85rem;
        text-transform: capitalize;
      }
    }

    .packaging {
      width: 100%;
      margin-top: 1.5rem;

      .section-title {
        color: ${({ theme }) => theme.text.primary};
        font-weight: 600;
        font-size: 0.95rem;
        margin-bottom: 0.75rem;
      }

      .levels {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
      }

      /* The layer value is a full sentence ("Box (contains 3 Crates)"); the
         type is already capitalized in JS, so don't capitalize every word. */
      .item .value {
        text-transform: none;
      }

      .summary {
        margin-top: 1rem;
        color: ${({ theme }) => theme.text.prim_100};
        font-weight: 600;
        font-size: 0.85rem;
      }

      .empty {
        color: ${({ theme }) => theme.text.muted_200};
        font-weight: 400;
        font-size: 0.85rem;
      }
    }
  }

  .query-details {
    width: 100%;
    margin-top: 3rem;
    padding-left: 3rem;
    h2 {
      color: ${({ theme }) => theme.text.input};
      font-size: 1.1rem;
      font-weight: 500;
    }

    h3 {
      margin-top: 0.5rem;
      font-size: 0.85rem;
      font-weight: 400;
      color: ${({ theme }) => theme.text.muted_200};
    }
  }

  .controls {
    width: 100%;
    display: flex;
    margin-top: 2rem;
    justify-content: flex-end;
    align-items: center;
    gap: 5rem;
    padding-right: 4rem;

    @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
      justify-content: space-between;
      padding: 0;
      padding-bottom: 2rem;
    }
  }
`;
